// rtk详情
export default {
    operatorInformation: 'Operator Information',
    residualFlow: 'Residual Flow',
    validUntil: 'Valid Until',
    renew: 'Renew',
    SCP: 'Scan Code Payment',
    connected: 'Connected',
    notConnected: 'Not Connected',
    bindingType: 'Binding type',
    private: 'Private',
    public: 'Public',
}